import { Video } from "@kalyzee/kast-web-sdk/web-components";
import { PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import { MeetingSourceExtended } from "../../hooks/meeting";

import styles from "./MediaSourceViewer.module.css";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";

export interface MediaSourceViewerProps {
  sources: MeetingSourceExtended[];
  onClick?: () => void;
  selected?: boolean;
}

export const MediaSourceViewer: React.FC<MediaSourceViewerProps> = ({
  sources,
  onClick,
  selected,
}) => {
  const selfStreams = useAppStoreSelector(store => store.selfStreams);

  // Taking first visible for now, TODO selection
  const visibleSource = sources.find(s => s.visible);
  if (!visibleSource) return null;

  const localStream = visibleSource.name ? selfStreams?.[visibleSource.name] : undefined;

  return (
    <PrimaryButton
      className={styles.container}
      onClick={onClick}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 4,
          overflow: "hidden", // crop video
          height: "100%",
          aspectRatio: "16/9",
        }}
      >
        {localStream ? (
          <Video
            style={{ flex: 1, height: "100%", minWidth: 0, objectFit: "cover" }}
            src={localStream}
            autoPlay
            muted
          />
        ) : (
          <div
            style={{
              fontSize: "0.6em",
              flex: 1,
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Pas de Media
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px 3px",
          height: "100%",
        }}
      >
        <ReactIcons.Settings
          style={{
            width: 25,
            height: 25,
            color: selected ? "var(--color-element-pink)" : "var(--color-secondary-side-bar-icon)",
          }}
        />
      </div>
    </PrimaryButton>
  );
}